import { render, staticRenderFns } from "./PanelThanks.vue?vue&type=template&id=3e58e859&scoped=true&"
import script from "./PanelThanks.vue?vue&type=script&lang=js&"
export * from "./PanelThanks.vue?vue&type=script&lang=js&"
import style0 from "./PanelThanks.vue?vue&type=style&index=0&id=3e58e859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58e859",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
